export function normalizeString(rawString: string, emptySpaceReplacer = ''): string {
  if (!rawString?.length) {
    return '';
  }
  return rawString
    .toLowerCase()
    .replaceAll(' ', emptySpaceReplacer)
    .replace(/[^a-zA-Z0-9-]/g, '')
}